'use client';

import React, { useState } from 'react';
import styles from './eventhero.module.scss'

const SearchComponent = ({ search, setSearch }) => {
  const [serComponent, setSerComponent] = useState(search || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearch(serComponent);
  };

  return (
    <form className={styles.waitlistform} onSubmit={handleSubmit}>
      <input
        type='text'
        placeholder='Search event'
        value={serComponent}
        onChange={(e) => setSerComponent(e.target.value)}
      />

      <button type='submit' className={styles.waitlistbtn}>
        Search
      </button>
    </form>
  );
};

export default SearchComponent;
